export const validateAcademicsDegree = (
  formik: any,
  index: number,
  showErrorsInputs: boolean
) => {
  return (
    (showErrorsInputs ||
      (formik?.touched?.academicEducations &&
        formik?.touched?.academicEducations[index] &&
        formik?.touched?.academicEducations[index]?.degree)) &&
    formik?.errors?.academicEducations &&
    formik?.errors?.academicEducations[index] &&
    formik?.errors?.academicEducations[index]?.degree
  );
};

export const validateLanguage = (
  formik: any,
  index: number,
  showErrorsInputs: boolean
) => {
  return (
    (showErrorsInputs ||
      (formik?.touched?.languages &&
        formik?.touched?.languages[index] &&
        formik?.touched?.languages[index]?.language)) &&
    formik?.errors?.languages &&
    formik?.errors?.languages[index] &&
    formik?.errors?.languages[index]?.language
  );
};

export const validateJobPlace = (
  formik: any,
  index: number,
  showErrorsInputs: boolean
) => {
  return (
    (showErrorsInputs ||
      (formik?.touched?.jobExperiences &&
        formik?.touched?.jobExperiences[index] &&
        formik?.touched?.jobExperiences[index]?.jobPlace)) &&
    formik?.errors?.jobExperiences &&
    formik?.errors?.jobExperiences[index] &&
    formik?.errors?.jobExperiences[index]?.jobPlace
  );
};

export const validateJobFunction = (
  formik: any,
  index: number,
  showErrorsInputs: boolean
) => {
  return (
    (showErrorsInputs ||
      (formik?.touched?.jobExperiences &&
        formik?.touched?.jobExperiences[index] &&
        formik?.touched?.jobExperiences[index]?.jobFunction)) &&
    formik?.errors?.jobExperiences &&
    formik?.errors?.jobExperiences[index] &&
    formik?.errors?.jobExperiences[index]?.jobFunction
  );
};

export const validateStartDate = (
  formik: any,
  index: number,
  showErrorsInputs: boolean
) => {
  return (
    (showErrorsInputs ||
      (formik?.touched?.jobExperiences &&
        formik?.touched?.jobExperiences[index] &&
        formik?.touched?.jobExperiences[index]?.startDate)) &&
    formik?.errors?.jobExperiences &&
    formik?.errors?.jobExperiences[index] &&
    formik?.errors?.jobExperiences[index]?.startDate
  );
};

export const validateEndDate = (formik: any, index: number) => {
  return (
    formik?.touched?.jobExperiences &&
    formik?.touched?.jobExperiences[index] &&
    formik?.touched?.jobExperiences[index]?.endDate &&
    formik?.errors?.jobExperiences &&
    formik?.errors?.jobExperiences[index] &&
    formik?.errors?.jobExperiences[index]?.endDate
  );
};

export const validateTasks = (
  formik: any,
  index: number,
  showErrorsInputs: boolean
) => {
  return (
    (showErrorsInputs ||
      (formik?.touched?.jobExperiences &&
        formik?.touched?.jobExperiences[index] &&
        formik?.touched?.jobExperiences[index]?.tasks)) &&
    formik?.errors?.jobExperiences &&
    formik?.errors?.jobExperiences[index] &&
    formik?.errors?.jobExperiences[index]?.tasks
  );
};

export const validateEducationalAttainment = (formik: any, index: number) => {
  return (
    formik?.touched?.academicEducations &&
    formik?.touched?.academicEducations[index] &&
    formik?.touched?.academicEducations[index]?.educationalAttainment &&
    formik?.errors?.academicEducations &&
    formik?.errors?.academicEducations[index] &&
    formik?.errors?.academicEducations[index]?.educationalAttainment
  );
};

export const validateAcademicsCountry = (formik: any, index: number) => {
  return (
    formik?.touched?.academicEducations &&
    formik?.touched?.academicEducations[index] &&
    formik?.touched?.academicEducations[index]?.country &&
    formik?.errors?.academicEducations &&
    formik?.errors?.academicEducations[index] &&
    formik?.errors?.academicEducations[index]?.country
  );
};

export const validateAcademicsStartDate = (formik: any, index: number) => {
  return (
    formik?.touched?.academicEducations &&
    formik?.touched?.academicEducations[index] &&
    formik?.touched?.academicEducations[index]?.startDate &&
    formik?.errors?.academicEducations &&
    formik?.errors?.academicEducations[index] &&
    formik?.errors?.academicEducations[index]?.startDate
  );
};

export const validateAcademicsEndDate = (formik: any, index: number) => {
  return (
    formik?.touched?.academicEducations &&
    formik?.touched?.academicEducations[index] &&
    formik?.touched?.academicEducations[index]?.endDate &&
    formik?.errors?.academicEducations &&
    formik?.errors?.academicEducations[index] &&
    formik?.errors?.academicEducations[index]?.endDate
  );
};

export const validateAcademicsStatus = (formik: any, index: number) => {
  return (
    formik?.touched?.academicEducations &&
    formik?.touched?.academicEducations[index] &&
    formik?.touched?.academicEducations[index]?.careerStatus &&
    formik?.errors?.academicEducations &&
    formik?.errors?.academicEducations[index] &&
    formik?.errors?.academicEducations[index]?.careerStatus
  );
};

export const validateSpokenLevel = (formik: any, index: number) => {
  return (
    formik?.touched?.languages &&
    formik?.touched?.languages[index] &&
    formik?.touched?.languages[index]?.spokenLevel &&
    formik?.errors?.languages &&
    formik?.errors?.languages[index] &&
    formik?.errors?.languages[index]?.spokenLevel
  );
};

export const validateWrittenLevel = (formik: any, index: number) => {
  return (
    formik?.touched?.languages &&
    formik?.touched?.languages[index] &&
    formik?.touched?.languages[index]?.writtenLevel &&
    formik?.errors?.languages &&
    formik?.errors?.languages[index] &&
    formik?.errors?.languages[index]?.writtenLevel
  );
};

export const validateJobType = (formik: any, index: number) => {
  return (
    formik?.touched?.jobExperiences &&
    formik?.touched?.jobExperiences[index] &&
    formik?.touched?.jobExperiences[index]?.jobType &&
    formik?.errors?.jobExperiences &&
    formik?.errors?.jobExperiences[index] &&
    formik?.errors?.jobExperiences[index]?.jobType
  );
};

export const validateDocumentReferred = (formik: any, index: number) => {
  return (
    formik?.touched?.referreds &&
    formik?.touched?.referreds[index] &&
    formik?.touched?.referreds[index]?.document &&
    formik?.errors?.referreds &&
    formik?.errors?.referreds[index] &&
    formik?.errors?.referreds[index]?.document
  );
};
